module.exports = __webpack_public_path__ + "img/03ioz5wpMR.ff793cb4.png";